import { MedplumClient } from '@medplum/core';
import { fetchBot } from './services';
import { ApplyPreferredPharmacyTemplateInput } from '@bariendo/lib/patient';

export async function applyPreferredPharmacy(
  medplum: MedplumClient,
  input: ApplyPreferredPharmacyTemplateInput
): Promise<void> {
  await fetchBot(medplum, 'apply-preferred-pharmacy', input);
}
